"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class TelemetryOperation extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'telemetryOperation';
        this._operationType = initParams.operation_type;
        this._parameters = initParams.parameters;
        this._status = initParams.status;
        this._startTs = initParams.start_ts;
        this._endTs = initParams.end_ts;
    }
    set operationType(value) {
        console.error('Do not set objects this way');
    }
    get operationType() {
        return this._operationType;
    }
    set parameters(value) {
        console.error('Do not set objects this way');
    }
    get parameters() {
        return this._parameters;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
    set startTs(value) {
        console.error('Do not set objects this way');
    }
    get startTs() {
        return this._startTs;
    }
    set endTs(value) {
        console.error('Do not set objects this way');
    }
    get endTs() {
        return this._endTs;
    }
}
exports.default = TelemetryOperation;
//# sourceMappingURL=telemetryOperation.js.map